import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';
import {QARService, ReportParticipationEntity, SORUserEntity} from '../services/qar.service';

// import {MappingSystemUser2SORUserEntity, QARService, SORUserEntity} from '../services/qar.service';
import {AppUser, AppUserData} from '../framework/AppUser';
import {UITableComponent} from '../framework/ui/table';
import {Observable, of} from 'rxjs';
import {FormControl} from '@angular/forms';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';

@Component({
	selector: 'app-page-users',
	templateUrl: 'users.html',
	providers: [QARService, AppUser]
})
export class PageUsersComponent implements OnInit {

	constructor(public api: QARService, public user: AppUser) {
	}

	ngOnInit() {
		this.users_init();
	}

	public users = {
		autocomplete$: null,
		searchedUser: null,
		searchingUserDropdown: false,
		searching: false,
		searchedDate: null,
		isSearchingWithDate: false,
		newAlias: {
			sorUserIdFormControl: new FormControl(),
			sorUserIdFormControl2: new FormControl(),
			systemId: null,
			username: null
		},
		chunker: (new Chunker([])),
		chunkedData: [],
		tableHeaders: [
			{id: 'SystemName', label: 'System Name', filterable: true},
			{id: 'Username', label: 'User Local Alias', filterable: true},
			{id: 'RoleName', label: 'User Role', filterable: true},
			{id: 'MappedRoleName', filterable: true, label: 'Standard Role Name'},
			{id: 'AdGroups', label: 'AD Group Name', filterable: true},
			{id: 'FirstReported', label: 'First Time Reported'},
			{id: 'LastReported', label: 'Last Time Reported'},
		]
	};


	users_init() {
		this.users.autocomplete$ = this.users.newAlias.sorUserIdFormControl.valueChanges.pipe(
			startWith(''),
			// delay emits
			debounceTime(300),
			// use switch map so as to cancel previous subscribed events, before creating new once
			switchMap(value => {
				if (value !== '') {
					return this.users_lookup(value);
				} else {
					// if no value is present, return null
					return of(null);
				}
			}));
	}

	user_dropdownType() {
		this.users.searchingUserDropdown = true;
	}

	public users_selectSearchDate(d: string) {
		console.log('users_selectSearchDate', d, this.format_date(new Date(Date.parse(d))));
		this.users.searchedDate = this.format_date(new Date(Date.parse(d)));
	}

	autocompleteDisplayUser(w: SORUserEntity) {
		if (!w) {
			return '';
		}
		return w.FirstName + ' ' + w.LastName + ' ( ' + w.Login + ' )';
	}

	public users_lookup(value: string): Observable<SORUserEntity[]> {
		if (typeof value === 'string') {
			return this.api.searchSORUser(value).pipe(
				map(results => {
					this.users.searchingUserDropdown = false;
					return results;
				})
			);
		} else {
			this.users.searchingUserDropdown = false;
			return new Observable<SORUserEntity[]>();
		}
	}

	user_search() {

		// user info
		this.users.searchedUser = null;
		const sorUserId = this.users.newAlias.sorUserIdFormControl.value?.Id;
		this.api.retrieveSORUserById(sorUserId).toPromise().then((u) => {
			this.users.searchedUser = u;
		});


		// actual search
		const todate = this.users.searchedDate;

		this.users.searching = true;
		this.users.isSearchingWithDate = false;

		if (!sorUserId) {
			this.alert('please select a user', 'Warning');
		} else {
			this.api.retrieveUserRolesAtDate(sorUserId, todate ? todate : null).then(r => {
				this.users.searching = false;
				this.users.chunker = new Chunker(r);
				this.users.isSearchingWithDate = todate != null;
			}, e => {
				console.error('e', e.status);
				this.users.searching = false;
				if (e.status === 409) {
					this.alert('There is no record', 'Warning');
				} else {
					this.alert('Sorry, there are some issue', 'Warning');
				}
			});
		}
	}

	public date_modify(odate, direction) {
		console.log('date_modify', odate, direction);
		if (!odate) {
			return this.format_date(new Date());
		}
		let date = new Date(Date.parse(odate) + 24 * 60 * 60 * 1000 * (direction == '+' ? 1 : -1));
		return this.format_date(date);
	}

	public format_date(d: Date) {
		return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate();
	}

	// !ALERT
	modalAlert = {
		display: false,
		title: '',
		text: '', cb: (yesorno) => {
		}
	};

	public alert(text, title = 'Alert') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}


}
